<template>
  <!-- 总量模式  -->
  <div class="content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bolder">基本信息</span>
        <el-button v-if="pondData.status == 1" style="margin-left:10px" size="mini" type="primary" v-hasPermi="['pondManage:allocation']" @click="handleCardAllocation">池卡分配</el-button>
      </div>
      <el-descriptions :column="3" :contentStyle="{'font-size': '15px'}" :labelStyle="{'font-weight': 'bold','color':'#303133'}">
          <el-descriptions-item label="池ID">{{pondData.id}}</el-descriptions-item>
          <el-descriptions-item label="池代理商">{{pondData.companyName}}</el-descriptions-item>
          <el-descriptions-item label="池名称">{{pondData.poolName}}</el-descriptions-item>
          <el-descriptions-item label="池类型">
            <el-tag type="success">{{pondData.poolType}}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="运营类型">
             <el-tag style="margin-right:8px;" size="small" :key="item" v-for="item in pondData.operationTypes">{{item}}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="池状态">
            <el-tag size="small" v-if="pondData.status == 1">启用中</el-tag>
            <el-tag size="small" type="warning" v-else>未启用</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="自动停开机" v-if="adminShow">
            <el-tag size="small" v-if="pondData.stopCard == 1">是</el-tag>
            <el-tag size="small" type="warning" v-else>不停机</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="池成员">{{pondData.cardCount}}/PCS</el-descriptions-item>
          <el-descriptions-item label="单卡月峰值">
            <span v-if="editShow">
              {{pondData.strSingleFlowLimit}}
              <i class="el-icon-edit" @click="editShow = !editShow"></i>
            </span>
            <span v-if="!editShow">
              <el-input v-model="singleFlowLimit" style="width: 90px;" @blur="handleSingleFlowLimit" class="span-input">
                <i
                  class="el-icon-close el-input__icon"
                  slot="suffix"
                  @click="editShow = true">
                </i>
              </el-input>
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="单卡停机保号费">{{pondData.cardProductFee}} 元/月</el-descriptions-item>
          <el-descriptions-item label="单卡功能管理费">{{pondData.cardFunctionFee}} 元/月</el-descriptions-item>
          <el-descriptions-item label="池初始总量">{{pondData.strPoolTotalFlow}}</el-descriptions-item>
          <el-descriptions-item label="流量池单价">{{pondData.poolTotalFlowFee}} 元/月</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{pondData.createTime}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
    <!-- 池套餐详情 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bolder">池详情</span>
        <el-button style="margin-left:10px" v-if="pondData.status == '1'" size="mini" type="primary" @click="poolRenewalProduct">续费</el-button>
      </div>
      <el-form :inline="true" label-width="68px" v-if="lastThreeMonthDate && lastThreeMonthDate.length>0">
        <el-form-item>
          <el-select v-model="month" placeholder="请选择月份" @change="initPoolProductDetails" clearable @clear="initPoolProductDetails" >
            <el-option
                v-for="item in lastThreeMonthDate"
                :key="item.month"
                :label="item.month"
                :value="item.month">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="tableDisplayData" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}">
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="poolName" label="池名称" align="center"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
        <el-table-column prop="endTime" label="到期时间" align="center"></el-table-column>
        <el-table-column prop="useFlow" label="已用流量(M)" align="center" ></el-table-column>
        <el-table-column prop="totalFlow" label="池总量(M)" align="center" :formatter="dataFormat"></el-table-column>
        <el-table-column label="操作" align="center" width="200" fixed="right" v-if="pondData.poolType == '总量模式'">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == '1' || scope.row.status == '0'" size="mini"  type="primary" plain  @click="purchasePackage(scope.row)" v-hasPermi="['pondManage:pondDetails:product']">加油包</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="expand-bar" v-if="poolDetailProducts.length > 3" @click="isExpanded = !isExpanded">
        <el-divider>
          <span class="expand-text">
            <i :class="isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            {{ isExpanded ? '收起' : '展开更多' }}
          </span>
        </el-divider>
      </div>
    </el-card>
    <!-- 池成员 -->
    <PoolCardList ref="childCardList" :poolId="poolId" :userId="pondData.userId" :status="pondData.status"></PoolCardList>
    <!-- 加油包的弹窗 -->
    <el-dialog @close="purchaseDialogClose" :visible.sync="dialogPurchase" title="流量池加油包" width="640px" :close-on-click-modal="false">
      <el-form :model="purchaseForm" ref="purchaseForm">
        <el-form-item label="加油包名称:" prop="packName" label-width="100px">
          <el-select v-model="purchaseForm.productId" filterable placeholder="加油包名称"  @change="selectChangePackage" >
            <el-option v-for="(item,index) in productDatas" :key="index" :label="item.packName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="加油包总量:" prop="packFlow" label-width="100px">
          <span>{{purchaseForm.packFlow}} MB</span>
        </el-form-item>
        <el-form-item label="有效时间:" prop="validDate" label-width="100px">
          <span>{{purchaseForm.endTime}}</span>
        </el-form-item>
        <el-form-item label="价格:" prop="packPrice" label-width="100px">
          <span style="color: red;">{{purchaseForm.packPrice}} 元</span>
        </el-form-item>
        <el-form-item label="支付方式:" label-width="100px">
          <div class="pay-list" v-if="!adminShow">
            <div class="pay-item" :class="{'checked': isCheckedPay === 1}" @click="checkPayWay(1)">
              <img src="../../../assets/img/zhifu-weixinzhifu.png" alt="微信支付" data-type="1">
              <div class="text"><span>微信支付</span></div>
            </div>
            <div class="pay-item" :class="{'checked': isCheckedPay === 2}" @click="checkPayWay(2)">
              <img src="../../../assets/img/zhifubao.png" alt="支付宝支付" data-type="2">
              <div class="text"><span>支付宝支付</span></div>
            </div>
            <div class="pay-item" :class="{'checked': isCheckedPay === 3}" @click="checkPayWay(3)">
              <img src="../../../assets/img/yuezhifu4.png" alt="余额支付" data-type="3">
              <div class="text"><span>余额支付</span></div>
            </div>
          </div>
          <div class="pay-list" v-if="adminShow" style="width:300px">
            <div class="pay-item" :class="{'checked': isCheckedPay === 1}" @click="checkPayWay(1)">
              <img src="../../../assets/img/xitong.png" alt="系统支付" data-type="4">
              <div class="text"><span>系统支付</span></div>
            </div>
            <div class="pay-item" :class="{'checked': isCheckedPay === 3}" @click="checkPayWay(3)">
              <img src="../../../assets/img/yuezhifu4.png" alt="余额支付" data-type="3">
              <div class="text"><span>代理商余额支付</span></div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <slot></slot>
      <img class="reg-img" :src="imgSrc" v-if="imgSrc"/>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="purchaseSubmit">支 付</el-button>
        <el-button @click="cancelPurchase">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 池子续费 -->
    <el-dialog @close="poolProductClose" :visible.sync="showPoolProduct" title="流量池续费" width="650px" :close-on-click-modal="false">
      <el-form :model="poolProductForm" ref="poolProductForm">
        <el-form-item label="池名称:" prop="poolName" label-width="100px">
          <el-input v-model="poolProductForm.poolName" placeholder="池名称" style="width:60%" disabled></el-input>
        </el-form-item>
        <el-form-item label="时间:" prop="months" label-width="100px">
          <el-input-number v-model="poolProductForm.months" :min="1" style="width:60%"></el-input-number>
          <span>月</span>
        </el-form-item>
        <el-form-item label="池总量:" prop="totalFlow" label-width="100px">
          <el-input v-model="poolProductForm.totalFlow" placeholder="池总量" style="width:60%" disabled>
            <template slot="append">MB</template>
          </el-input>
        </el-form-item>
        <el-form-item label="价格:" prop="flowPrice" label-width="100px">
          <span style="color: red;">{{poolProductForm.flowPrice * poolProductForm.months}}元 </span>
        </el-form-item>
        <el-form-item label="支付方式:" label-width="100px">
          <div class="pay-list" v-if="!adminShow">
            <div class="pay-item" :class="{'checked': isCheckedPay === 1}" @click="checkPayWay(1)">
              <img src="../../../assets/img/zhifu-weixinzhifu.png" alt="微信支付" data-type="1">
              <div class="text"><span>微信支付</span></div>
            </div>
            <div class="pay-item" :class="{'checked': isCheckedPay === 2}" @click="checkPayWay(2)">
              <img src="../../../assets/img/zhifubao.png" alt="支付宝支付" data-type="2">
              <div class="text"><span>支付宝支付</span></div>
            </div>
            <div class="pay-item" :class="{'checked': isCheckedPay === 3}" @click="checkPayWay(3)">
              <img src="../../../assets/img/yuezhifu4.png" alt="余额支付" data-type="3">
              <div class="text"><span>余额支付</span></div>
            </div>
          </div>
          <div class="pay-list" v-if="adminShow" style="width:300px">
            <div class="pay-item" :class="{'checked': isCheckedPay === 1}" @click="checkPayWay(1)">
              <img src="../../../assets/img/xitong.png" alt="系统支付" data-type="4">
              <div class="text"><span>系统支付</span></div>
            </div>
            <div class="pay-item" :class="{'checked': isCheckedPay === 3}" @click="checkPayWay(3)">
              <img src="../../../assets/img/yuezhifu4.png" alt="余额支付" data-type="3">
              <div class="text"><span>代理商余额支付</span></div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <img class="reg-img" :src="imgSrc" v-if="imgSrc"/>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="payPoolProduct">支 付</el-button>
        <el-button @click="poolProductClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  changeFlowPoolLimit,
  poolGetFlowPoolDetail,
  poolGetFlowPoolRenewRecord,
  poolGetTotalTypePoolPack,
  poolBuyPoolPack,
  poolCreateOrder,
  createPoolQrCodeOrder,
  poolRenewFlowPool,
  poolQueryOrderStatus
} from "@/api/api.js";
import PoolCardList from "./PoolCardList.vue";
export default {
  name:'totalPondDetail',
  components: { 
    PoolCardList
  },
  props: {
    poolId: {
      type: String
    }
  },
  data() {
    return{
      pondData:{},
      editShow:true,
      singleFlowLimit:"",
      month:undefined,
      lastThreeMonthDate:[],
      poolDetailProducts:[],
      isExpanded: false,
      dialogPurchase:false,
      timer:null,
      imgSrc:'',
      purchaseForm:{},
      isCheckedPay:1,
      productDatas:[],
      currentPoolProduct:{},
      orderId:undefined,
      showPoolProduct:false,
      poolProductForm:{
        months:1
      }
    }
  },
  computed: {
    adminShow(){
        return this.$store.getters.user.userType =='1'
    },
    tableDisplayData(){
      if (this.isExpanded || this.poolDetailProducts.length <= 3) {
        return this.poolDetailProducts;
      }
      // 折叠时取最新时间的3条，按时间升序展示
      const top3 = [...this.poolDetailProducts]
        .sort((a, b) => new Date(b.startTime) - new Date(a.startTime))
        .slice(0, 3)
        .sort((a, b) => new Date(a.startTime) - new Date(b.startTime));
      return top3;
    },
  },
  methods: {
    dataFormat(row, column, value){
      return value == null ? '-' : value
    },
    //卡分配
    handleCardAllocation(){
      this.$router.push({name:"pondTransfer",params: { poolId: this.poolId , userId:this.pondData.userId }});
    },
    // 池套餐详情
    initPoolProductDetails(){
      let poolId = this.poolId
      poolGetFlowPoolRenewRecord({poolId , month:this.month}).then(res => {
        this.lastThreeMonthDate = res.data.data.lastThreeMonthDate;
        this.poolDetailProducts = res.data.data.tableDetailData;
      })
    },
    // 流量池详情
    informationData(){
      let poolId = this.poolId
      poolGetFlowPoolDetail({poolId}).then(res => {
        this.pondData = res.data.data;
      })
    },
    handleSingleFlowLimit(){
      if(!this.singleFlowLimit){
        return this.$message.error("请输入池峰值");
      }
      let params = {
        poolId:this.poolId,
        singleFlowLimit:this.singleFlowLimit
      };
      changeFlowPoolLimit(params).then(res=>{
        this.pondData.strSingleFlowLimit = res.data.data;
        this.editShow = true;
        this.$refs.childCardList.initPoolCardData();
      })
    },
    poolTotalPoolPack(){
      poolGetTotalTypePoolPack({poolId:this.poolId}).then(res=>{
        this.productDatas = res.data.data
        let form = res.data.data || []
        this.purchaseForm.productId = form[0].id;
        this.purchaseForm.packFlow = form[0].packFlow;
        this.purchaseForm.packPrice = form[0].packPrice;
      })
    },
    purchasePackage(row){
      this.poolTotalPoolPack()
      this.currentPoolProduct = row
      this.dialogPurchase = true;
      this.purchaseForm.endTime = row.endTime
    },
    purchaseDialogClose(){
      clearInterval(this.timer);
      this.timer = null;
      this.imgSrc = "";
    },
    //去充值加油包
    purchaseSubmit(){
      if(this.adminShow || this.isCheckedPay == 3){
        this.payOrder();
        return;
      }
      let params = {
        money: this.purchaseForm.packPrice,
        poolId: this.poolId,
        productId: this.purchaseForm.productId,
        poolProductId: this.currentPoolProduct.id,
        orderType:'2',
        type:this.isCheckedPay
      };
      poolCreateOrder(params).then(res=>{
        if (res.data.code == 200) {
          let orderId = res.data.data.orderId
          createPoolQrCodeOrder({orderId:orderId }).then(res=>{
            this.imgSrc = "data:image/jpeg;base64," + res.data.data;
          })
          this.timer = setInterval(() => {
            let params ={
              poolProductId:this.currentPoolProduct.id,
              packId:this.purchaseForm.productId,
              orderId:orderId
            }
            poolQueryOrderStatus(params).then(res=>{
              if(res.data.data.code == 200){
                this.dialogPurchase = false;
                this.initPoolProductDetails();
                this.$message({
                  duration:3000,
                  message: '支付成功',
                  type: 'success',
                });
                clearInterval(this.timer);
                this.timer = null;
              }
            })
          }, 3000);
        }
      })
    },
    payOrder(){
      let params ={
        poolProductId:this.currentPoolProduct.id,
        type:this.isCheckedPay,
        packId:this.purchaseForm.productId,
      }
      poolBuyPoolPack(params).then(res=>{
        if(res.data.code == 200){
          this.dialogPurchase = false;
          this.initPoolProductDetails();
          this.$message({
            duration:3000,
            message: '支付成功',
            type: 'success',
          });
        }else if(res.data.code == 414){
          this.$message.error(res.data.message+ "，请选择其他支付方式");
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    cancelPurchase(){
      this.dialogPurchase = false;
      clearInterval(this.timer);
      this.timer = null;
      this.imgSrc = "";
    },
    checkPayWay(type){
      this.isCheckedPay = type;
    },
    selectChangePackage(productId){
      let product = this.productDatas.find(item=>item.id===productId) || {};
      this.purchaseForm = {
        endTime:this.purchaseForm.endTime
      }
      this.purchaseForm.productId = product.id;
      this.purchaseForm.packFlow = product.packFlow;
      this.purchaseForm.packPrice = product.packPrice;

    },
    //池套餐生成
    poolRenewalProduct(){
      this.showPoolProduct = true
      this.poolProductForm.poolId= this.poolId
      this.poolProductForm.poolName = this.pondData.poolName
      this.poolProductForm.flowPrice = this.pondData.poolTotalFlowFee
      this.poolProductForm.totalFlow = this.pondData.poolTotalFlow
    },
    poolProductClose(){
      this.poolProductForm.months = 1
      this.showPoolProduct = false
      clearInterval(this.timer);
      this.timer = null;
      this.imgSrc = "";
    },
    //流量池续费
    payPoolProduct(){
      if(this.adminShow || this.isCheckedPay == 3){
        this.savePoolRenewal();
        return;
      }
      let params = {
        money: this.poolProductForm.flowPrice * this.poolProductForm.months,
        total: this.poolProductForm.months,
        poolId: this.poolId,
        orderType: "1",
        type:this.isCheckedPay
      };
      poolCreateOrder(params).then(res=>{
        if (res.data.code == 200) {
          let orderId = res.data.data.orderId
          createPoolQrCodeOrder({orderId:orderId }).then(res=>{
            this.imgSrc = "data:image/jpeg;base64," + res.data.data;
          })
          this.timer = setInterval(() => {
            let params = {
              poolId:this.poolId,
              months:this.poolProductForm.months,
              orderId:orderId
            }
            poolQueryOrderStatus(params).then(res=>{
              if(res.data.data.code == 200){
                  this.showPoolProduct = false;
                  this.initPoolProductDetails();
                  this.$message({
                    duration:3000,
                    message: '支付成功',
                    type: 'success',
                  });
                  clearInterval(this.timer);
                  this.timer = null;
              }
            })
          }, 3000);
        }
      })
    },
    //流量池余额续费
    savePoolRenewal(){
      let params = {
        poolId:this.poolId,
        type:this.isCheckedPay,
        months:this.poolProductForm.months,
      }
      poolRenewFlowPool(params).then(res=>{
        if(res.data.code == 200){
          this.showPoolProduct = false;
          this.initPoolProductDetails();
          this.$message({
            duration:3000,
            message: '续费成功',
            type: 'success',
          });
        }else if(res.data.code == 414){
          this.$message.error(res.data.message + "，请选择其他支付方式");
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
  },
  created() {
    this.informationData();
    this.initPoolProductDetails();
  },
};
</script>
<style scoped lang="less">
.box-card{
  margin-bottom: 4px;
}
.expand-bar {
  text-align: center;
  cursor: pointer;
  padding: 0 12px;
  margin-top: 15px;

  .el-divider {
    margin: 8px 0;
  }

  .expand-text {
    color: #409eff;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 4px;

    i {
      font-size: 12px;
    }
  }

  &:hover .expand-text {
    color: #66b1ff;
  }
}
.pay-list{
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;
  gap: 15px; 
  padding: 20px 20px 20px 0px;
  width: 500px;
  height: 31px;
  .pay-item{
    
    flex: 1;
    display: flex;
    flex-direction: row;
    text-align: center;
    justify-items: center;
    border: 1px solid #eeeeee;
    border-radius: 6px;
    &.checked{
      border: 1px solid #32c169;
      background: url(../../../assets/img/wx_payImg2.png) no-repeat right center;
      background-size: auto 31px;
      height: 31px;
      border-radius: 6px;
    }
    img{
      width:30px;
      height: 30px;
    }
    .text{
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center;
      flex: 1;
      height: 30px;
      line-height: 30px;
    }
  }

}
</style>


